import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "toast-text" }
const _hoisted_4 = ["src"]

import InfoAlertIcon from "../../assets/images/InfoAlertRed.svg";
import CloseIcon from "../../assets/images/Close.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorBanner',
  props: {
    message: {},
    visible: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "toast-bar" }, null, -1)),
        _createElementVNode("img", {
          src: _unref(InfoAlertIcon),
          alt: "Alert",
          class: "alert-icon"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
        _createElementVNode("button", {
          class: "toast-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("img", {
            src: _unref(CloseIcon),
            alt: "Close"
          }, null, 8, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})